const BACKEND_FAIL_MESSAGE = "Backend failed. Please contact the team to fix.";

/**
 * Returns a safe user-facing error string from an error or response.
 * Avoids showing "[object Object]" when backend returns an object as message.
 * Supports nested shapes like { message: { message: "User already exists", ... } }.
 */
export function getErrorMessage(err, fallback = BACKEND_FAIL_MESSAGE) {
  const raw = err?.response?.data?.message;
  let resolved = raw;

  if (Array.isArray(resolved) && resolved.length > 0 && typeof resolved[0] === "string") {
    resolved = resolved[0];
  } else if (resolved != null && typeof resolved === "object" && !Array.isArray(resolved)) {
    const inner = resolved.message ?? resolved.error;
    if (typeof inner === "string") {
      resolved = inner;
    } else {
      resolved = null;
    }
  }

  if (typeof resolved === "string") {
    const trimmed = resolved.trim();
    if (trimmed) {
      const isDuplicateAgentNameError =
        trimmed.includes("Invalid `prisma.agentLibrary.create()` invocation") &&
        trimmed.includes("Unique constraint failed on the fields: (`agent_name`)");
      if (isDuplicateAgentNameError) {
        return `${trimmed}. Maybe Agent name already exist crosscheck`;
      }
      return trimmed;
    }
  }

  const topLevel = err?.message;
  if (typeof topLevel === "string") {
    const trimmed = topLevel.trim();
    if (trimmed) return trimmed;
  }

  return fallback;
}

export { BACKEND_FAIL_MESSAGE };
